var StickyHandler,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

StickyHandler = (function() {
  function StickyHandler(element, container, elementOffset) {
    this.element = element;
    this.container = container;
    this.elementOffset = elementOffset;
    this.attachEvents = bind(this.attachEvents, this);
    this.windowHasHorizontalScroll = bind(this.windowHasHorizontalScroll, this);
    this.isWindowSmallerThanElement = bind(this.isWindowSmallerThanElement, this);
    this.shouldBeFixed = bind(this.shouldBeFixed, this);
    this.shouldBeAbsolute = bind(this.shouldBeAbsolute, this);
    this.shouldBeRelative = bind(this.shouldBeRelative, this);
    this.isFixedPositionOverrideRequired = bind(this.isFixedPositionOverrideRequired, this);
    this.getFixedCss = bind(this.getFixedCss, this);
    this.getAbsoluteCss = bind(this.getAbsoluteCss, this);
    this.getRelativeCss = bind(this.getRelativeCss, this);
    this.getCss = bind(this.getCss, this);
    this.updateCss = bind(this.updateCss, this);
    this.updatePosition = bind(this.updatePosition, this);
    this.scroll = bind(this.scroll, this);
    this.resize = bind(this.resize, this);
    this.updateDimensions = bind(this.updateDimensions, this);
    if (this.element.length) {
      this.container = this.container || $('body');
      if (this.window == null) {
        this.window = $(window);
      }
      this.document = $(document);
      this.parent = this.element.parent();
      this.sibling = this.parent.next();
      this.firstTick = true;
      if (this.elementOffset == null) {
        this.elementOffset = 0;
      }
      this.lastCss = {};
      this.scrollTop = this.window.scrollTop();
      this.isRtl = $('body').hasClass('rtl');
      this.attachEvents();
      this.updatePosition();
    }
  }

  StickyHandler.prototype.updateDimensions = function() {
    this.windowHeight = this.window.height();
    this.elementHeight = this.element.height();
    this.elementWidth = this.element.outerWidth();
    this.parentPadding = this.parent.outerWidth() - this.elementWidth;
    this.offsetLeft = this.isRtl ? this.element.offset().left : this.sibling.offset().left + this.sibling.outerWidth() + this.parentPadding - this.window.scrollLeft();
    this.containerBottomPosition = this.container.offset().top + this.container.height();
    this.scrollTop = this.window.scrollTop();
    this.elementTop = this.parent.offset().top - this.elementOffset;
    return this.elementBottomPosition = this.scrollTop + this.elementHeight;
  };

  StickyHandler.prototype.resize = function() {
    this.firstTick = true;
    return this.updatePosition();
  };

  StickyHandler.prototype.scroll = function() {
    this.firstTick = false;
    return this.updatePosition();
  };

  StickyHandler.prototype.updatePosition = function() {
    this.updateDimensions();
    this.css = this.getCss();
    if (!_.isEqual(this.css, this.lastCss)) {
      this.updateCss();
      return this.lastCss = _.clone(this.css);
    }
  };

  StickyHandler.prototype.updateCss = function() {
    return this.element.css(this.css);
  };

  StickyHandler.prototype.getCss = function() {
    if (this.isWindowSmallerThanElement() || this.shouldBeRelative() || this.isFixedPositionOverrideRequired()) {
      return this.getRelativeCss();
    } else if (this.shouldBeAbsolute()) {
      return this.getAbsoluteCss();
    } else {
      return this.getFixedCss();
    }
  };

  StickyHandler.prototype.getRelativeCss = function() {
    return {
      'position': 'relative',
      'top': (this.isFixedPositionOverrideRequired() && !this.isWindowSmallerThanElement()) ? this.scrollTop - this.elementTop : 0,
      'width': '',
      'left': '',
      'transform': 'translate3d(0px,0px,0px)',
      '-webkit-overflow-scrolling': 'touch',
      'overflow': 'hidden'
    };
  };

  StickyHandler.prototype.getAbsoluteCss = function() {
    return {
      'position': 'absolute',
      'top': this.containerBottomPosition - this.elementHeight - this.elementTop,
      'width': this.elementWidth,
      'left': this.parentPadding,
      'transform': 'translate3d(0px,0px,0px)',
      '-webkit-overflow-scrolling': 'touch',
      'overflow': 'hidden'
    };
  };

  StickyHandler.prototype.getFixedCss = function() {
    return {
      'position': 'fixed',
      'top': this.elementOffset,
      'width': this.elementWidth,
      'left': this.offsetLeft,
      'transform': 'translate3d(0px,0px,0px)',
      '-webkit-overflow-scrolling': 'touch',
      'overflow': 'hidden'
    };
  };

  StickyHandler.prototype.isFixedPositionOverrideRequired = function() {
    return this.shouldBeFixed() && (this.firstTick || this.windowHasHorizontalScroll());
  };

  StickyHandler.prototype.shouldBeRelative = function() {
    return this.scrollTop <= this.elementTop;
  };

  StickyHandler.prototype.shouldBeAbsolute = function() {
    return this.elementBottomPosition > this.containerBottomPosition;
  };

  StickyHandler.prototype.shouldBeFixed = function() {
    return !(this.shouldBeRelative() || this.shouldBeAbsolute());
  };

  StickyHandler.prototype.isWindowSmallerThanElement = function() {
    return this.windowHeight < this.elementHeight;
  };

  StickyHandler.prototype.windowHasHorizontalScroll = function() {
    return this.window.scrollLeft() !== 0;
  };

  StickyHandler.prototype.attachEvents = function() {
    if (window.addEventListener) {
      window.addEventListener('scroll', this.scroll, false);
      window.addEventListener('resize', this.resize, false);
    } else if (window.attachEvent) {
      window.attachEvent('onscroll', this.scroll);
      window.attachEvent('onresize', this.resize);
    }
    return $(document.body).on('modal-open', this.scroll);
  };

  return StickyHandler;

})();

module.exports = StickyHandler;

//# sourceMappingURL=data:application/json;base64,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
